import React from 'react';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { deleteSetOrder } from '@services/collectionService';

const DeleteSetOrder = ({ onClose, setOrderType, selectedProduct, updateProductCard }) => {
	const dispatch = useDispatch();

	const handleYes = async () => {
		try {
			dispatch(openLoader());
			const data = await deleteSetOrder(setOrderType === 'SET' ? 'set' : 'pack', selectedProduct?.id);
			updateProductCard(data, setOrderType, { type: 'DELETE', selectedProduct });
			dispatch(closeLoader());
			onClose();
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<ModalContainer onCloseModal={onClose} dialogClassName="delete-set-pack-modal">
			<div className="common-popup shadow-24dp">
				<div className="common-popup-body">
					<p className="regular-14">
						Do you want to delete the {setOrderType === 'SET' ? 'set' : 'pack'} and bring the
						styles to default?
					</p>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button size32" onClick={handleYes}>
							Yes
						</button>
						<button className="button gray-outline size32 ml-2" onClick={onClose}>
							No
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default DeleteSetOrder;
